<template>
    <d-card class="card-small mb-5">
      <spinner-dot v-if="loading" />
      <div v-else>
        <div class="header-data-table">
          <h5 class="header-data-table__heading">Mes demandes de régie</h5>
        </div>
        <data-table
          :data="regieDataGrid"
          :fields="gridColumnsTitle"
          :selectedFields="regieFields"
          :fieldsGrid="gridColumnsFields"
          :tableState="state"
          :count="count"
        ></data-table>
      </div>
      <simple-modal ref="reasonModal" :motif="selectedMotif" />
    </d-card>
  </template>
  
  <script>
  import SpinnerDot from "../layout/Loading/spinner-dot";
  import DataTable from "./dataTable";
  import regieRequestGrid from "../../data/dataTable/absceneRequestGrid.json";
  import SimpleModal from "../abscenceRequest/SimpleModal.vue";
  
  export default {
    name: "HistoryDaysOff",
    components: { SimpleModal, DataTable, SpinnerDot },
    props: ["reference"],
    data() {
      return {
        regieHistory: [],
        count: 0,
        model: {},
        selectedMotif: "",
        allStructures: [],
        // all values available for the table
        gridColumnsFields: regieRequestGrid.grid,
        gridColumnsTitle: regieRequestGrid.grid.map((grid) => grid.title),
        loading: true,
        regieFields: [
          "Date",
          "Structure",
          "Détails",
          "Montant",
          "Statut",
          "Voir ma demande",
        ],
  
        regieFieldsGridFill: {
          "Date": (request) => new Date(request.creationDate).toLocaleDateString("fr-FR"),
          Structure: (request) => this.getStructureName(request.structureID) ,
          "Détails": request => request.description,
          "Montant": (request) => `${request.effectiveAmount ? request.effectiveAmount :request.amount} €`,
          Statut: (request) => request.status || "En attente...",
          "Voir ma demande": (request) => {
              return {
                component: "button-td",
                class: "HistoryDemandsRegie-refuseButton",
                icon: "fa fa-eye",
                props: {reference : request.reference},
                action: this.showReason,
                id: request.reference,
              };

          },
        },
        state: {
          page: 1,
          perPage: 10,
          field: "creationDate",
          ascending: false,
        },
      };
    },
  
    watch: {
      state: {
        handler() {
          this.regieFetch();
        },
        deep: true,
      },
    },
  
    computed: {
      user() {
        return this.$store.state.user.informations;
      },
      regieDataGrid() {
        return this.regieHistory.map((user) => {
          const res = {};
          this.regieFields.forEach((field) => {
            if (this.regieFieldsGridFill[field]) {
              res[field] = this.regieFieldsGridFill[field](user);
            }
          });
          return res;
        });
      },
    },
  
    methods: {
      goToContract(reference) {
        this.$router.push(`/contracts/${reference}`);
      },
      showReason(reference) {
        this.$router.push(`/regies/${reference}`);
      },
      getStructureName(ref) {
        let name;
        this.allStructures.forEach((structure) => {
          if(structure.reference == ref) {
            name = structure.name;
          }
        })
        return name;
      },
      regieFetch() {
        this.loading = true;
        this.$services.regieRequestService
          .findAll(
            Object.assign({}, this.model, { applicantID : this.user.reference }),
            null,
            null,
            this.state.page,
            this.state.perPage,
            this.state.field,
            this.state.ascending,
            this.gridColumnsFields
          )
          .then((res) => {
            this.loading = false;
            this.count = res.data.count;
            this.regieHistory = res.data.data;
          });
          this.$services.structure
            .findAll()
            .then((response) => {
              this.allStructures = response.data;
            })
      },
    },
  
    mounted() {
      if (!this.reference) {
        this.model = { userReference: this.user.reference };
      } else {
        this.model = { userReference: this.reference };
      }
      this.regieFetch();
    },
  };
  </script>
  
<style>
.HistoryDemandsRegie-refuseButton {
  padding: 0;
  height: 30px !important;
  width: 40px !important;
  border: 1px #ABB6BF solid;
  color: #373a3d;
  font-size: 14px !important;
  /* width: 50px !important; */
}
</style>